import React, { Component } from "react";
import "./index.css"; // Ensure this imports the CSS file with the styles provided below
import { withRouter } from "react-router-dom";
import debounce from "lodash.debounce";
import { GetProductDetails } from "../../../../services";

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productId: "",
      productSuggestions: [],
      error: null,
    };
    this.suggestionsBoxRef = React.createRef();
    this.debouncedFetchSuggestions = debounce(this.fetchSuggestions, 300);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleInputChange = (event) => {
    const value = event.target.value;
    this.setState({ productId: value });

    if (value.length > 2) {
      this.debouncedFetchSuggestions(value);
    } else {
      this.setState({ productSuggestions: [] });
    }
  };

  fetchSuggestions = async (q) => {
    try {
      const res = await GetProductDetails.getAllProductQuerySearchList(q);
      if (res && res.products) {
        // Remove duplicates based on product id
        const uniqueProducts = res.products.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.id === value.id)
        );

        this.setState({ productSuggestions: uniqueProducts, error: null });
      } else {
        this.setState({ productSuggestions: [], error: "No products found." });
      }
    } catch (error) {
      console.error(error);
      this.setState({ error: "Search failed.", productSuggestions: [] });
    }
  };

  handleSuggestionClick = (product) => {
    this.setState({ productId: product.name, productSuggestions: [] });
    this.props.history.push(`/p/${product.id}`);
  };

  handleSearch = (event) => {
    event.preventDefault();
    const { productId } = this.state;
    if (productId) {
      this.props.history.push(`/tagsearch/${productId}`);
    }
  };

  handleClickOutside = (event) => {
    if (
      this.suggestionsBoxRef.current &&
      !this.suggestionsBoxRef.current.contains(event.target)
    ) {
      this.setState({ productSuggestions: [] });
    }
  };

  render() {
    const { productId, productSuggestions, error } = this.state;

    return (
      <div>
        <div className="search-section145">
          <div className="search-text-center">
            <div
              className="search-search-container"
              style={{ position: "relative" }}
            >
              <form onSubmit={this.handleSearch} className="search-search-form">
                <input
                  type="text"
                  placeholder="Search with Category, Tag & Product Name"
                  className="search-search-box"
                  value={productId}
                  onChange={this.handleInputChange}
                />
                <button type="submit" className="search-search-btn">
                  Search
                </button>
              </form>

              {productSuggestions.length > 0 && (
                <div
                  className="search-suggestions-box"
                  ref={this.suggestionsBoxRef}
                >
                  {productSuggestions.map((product) => (
                    <div
                      key={product.id}
                      className="search-suggestion-item"
                      onClick={() => this.handleSuggestionClick(product)}
                    >
                      <img
                        src={product.photo}
                        alt={product.name}
                        className="search-suggestion-img"
                        crossOrigin="anonymous"
                      />
                      <div className="search-suggestion-content">
                        <h4>{product.name}</h4>
                        <p>{product.sortDesc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {error && <p className="search-error-message">{error}</p>}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Search);
